import React from 'react';

interface DevsuLogoNavbarProps {
  className?: string;
}

/**
 * Icon + wordmark lockup as a single combined SVG (exact Figma export,
 * viewBox 107x25) — used only in the main navbar. Unlike DevsuLogoComplete
 * (which composes the separate DevsuLogoIcon/DevsuLogoText assets for use
 * elsewhere on the site), this is the literal single-path source asset, so
 * sizing is just a height utility + `aspect-[107/25]` with no separate
 * icon/text alignment math needed.
 */
export const DevsuLogoNavbar: React.FC<DevsuLogoNavbarProps> = ({
  className = '',
}) => (
  <svg
    width={107}
    height={25}
    viewBox="0 0 107 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    className={className}
  >
    <path
      d="M14.7006 0H3.23643C1.44896 0 0 1.34593 0 3.00713C0 4.66833 1.44896 6.01426 3.23643 6.01426H14.7006C16.4881 6.01426 17.937 4.66833 17.937 3.00713C17.937 1.34593 16.4881 0 14.7006 0Z"
      fill="url(#paint0_linear_navbar_logo)"
    />
    <path
      d="M14.7006 18.0406H3.23643C1.44896 18.0406 0 19.3866 0 21.0478C0 22.709 1.44896 24.0549 3.23643 24.0549H14.7006C16.4881 24.0549 17.937 22.709 17.937 21.0478C17.937 19.3866 16.4881 18.0406 14.7006 18.0406Z"
      fill="url(#paint1_linear_navbar_logo)"
    />
    <path
      d="M3.17552 15.0354C4.92931 15.0354 6.35104 13.689 6.35104 12.0282C6.35104 10.3675 4.92931 9.02112 3.17552 9.02112C1.42173 9.02112 0 10.3675 0 12.0282C0 13.689 1.42173 15.0354 3.17552 15.0354Z"
      fill="#03BA99"
    />
    <path
      d="M20.7621 9.02112H12.5315C10.778 9.02112 9.35596 10.367 9.35596 12.0282C9.35596 13.6894 10.778 15.0354 12.5315 15.0354H20.7621C22.5155 15.0354 23.9376 13.6894 23.9376 12.0282C23.9376 10.367 22.5155 9.02112 20.7621 9.02112Z"
      fill="#00F557"
    />
    <path
      d="M39.7465 7.63441C38.8783 7.07596 37.8287 6.7932 36.5951 6.7932C35.2608 6.7932 34.098 7.11131 33.1079 7.74751C32.1179 8.38372 31.3502 9.2532 30.8035 10.3574C30.2568 11.4615 29.9834 12.7226 29.9834 14.1407C29.9834 15.5587 30.2525 16.783 30.7907 17.8914C31.329 18.9999 32.0796 19.8764 33.0442 20.5211C34.0087 21.1658 35.1319 21.4881 36.4152 21.4881C37.8004 21.4881 38.959 21.1658 39.8881 20.5211C39.9901 20.4504 40.0893 20.3755 40.1856 20.2991V21.1007H43.2846V2.54053H39.7465V7.63441ZM39.8754 16.3589C39.6686 16.9951 39.3315 17.4885 38.8613 17.842C38.3924 18.194 37.7664 18.3707 36.9817 18.3707C36.1971 18.3707 35.6036 18.1813 35.122 17.8038C34.6404 17.4263 34.2821 16.9159 34.0498 16.2769C33.8175 15.6365 33.7014 14.9253 33.7014 14.1435C33.7014 13.3617 33.8218 12.6633 34.0626 12.0228C34.3034 11.3824 34.6759 10.872 35.1801 10.4888C35.6843 10.1071 36.3274 9.91485 37.1106 9.91485C37.8429 9.91485 38.4349 10.0916 38.8867 10.4436C39.3386 10.7956 39.6672 11.2905 39.874 11.9253C40.0808 12.5615 40.1842 13.3009 40.1842 14.1421C40.1842 14.9833 40.0808 15.7227 39.874 16.3589H39.8754Z"
      fill="white"
    />
    <path
      d="M57.863 7.82399C56.8375 7.13689 55.5939 6.79333 54.1308 6.79333C52.7527 6.79333 51.5346 7.10437 50.4766 7.72785C49.4171 8.35133 48.5871 9.22505 47.9837 10.3504C47.3804 11.4758 47.0801 12.7991 47.0801 14.3203C47.0801 15.7129 47.3874 16.9486 48.0036 18.0259C48.6183 19.1046 49.4709 19.9515 50.5601 20.5651C51.6493 21.1801 52.9085 21.4868 54.3376 21.4868C55.6803 21.4868 56.9182 21.1348 58.0499 20.4293C59.1816 19.7253 60.0102 18.737 60.5357 17.4646L57.0231 16.4594C56.7653 17.0263 56.3899 17.4604 55.8999 17.7615C55.4098 18.0627 54.8192 18.2125 54.1308 18.2125C53.0374 18.2125 52.2088 17.8577 51.6451 17.1493C51.2329 16.6305 50.9723 15.9533 50.8618 15.1191H60.6518C60.7977 13.4353 60.6263 11.9692 60.1348 10.7237C59.6434 9.47812 58.887 8.51109 57.8616 7.82399H57.863ZM54.2866 9.8344C55.3107 9.8344 56.05 10.1454 56.5018 10.7689C56.7993 11.1789 56.9961 11.7628 57.0981 12.5149H50.9581C51.0955 11.8717 51.3236 11.3387 51.6465 10.923C52.2102 10.1963 53.0912 9.8344 54.2866 9.8344Z"
      fill="white"
    />
    <path
      d="M69.5255 16.8236L66.2196 7.18152H62.707L67.7692 21.1031H71.2818L76.3439 7.18152H72.8313L69.5255 16.8236Z"
      fill="white"
    />
    <path
      d="M88.5517 13.7335C87.9101 13.3687 87.0603 13.0478 86.0008 12.7735C84.9159 12.4992 84.1086 12.2758 83.5802 12.1034C83.0505 11.9309 82.7021 11.764 82.535 11.6C82.3678 11.4375 82.2828 11.2353 82.2828 10.9935C82.2828 10.5892 82.4783 10.281 82.8706 10.0661C83.2616 9.85119 83.7814 9.76495 84.4272 9.80877C85.0901 9.85967 85.6156 10.0364 86.0023 10.3375C86.3903 10.6387 86.6141 11.0458 86.6736 11.5619L90.2641 10.9172C90.1437 10.0746 89.8222 9.34505 89.3024 8.72581C88.7812 8.10657 88.0999 7.63013 87.2557 7.29506C86.4116 6.95999 85.4428 6.79175 84.3508 6.79175C83.2587 6.79175 82.2432 6.96989 81.4132 7.32616C80.5818 7.68244 79.9387 8.18999 79.4827 8.8474C79.0266 9.50481 78.7986 10.281 78.7986 11.1745C78.7986 11.8885 78.9487 12.4964 79.2504 12.9983C79.5521 13.5016 80.0421 13.9328 80.722 14.2933C81.4019 14.6538 82.3098 14.9804 83.4471 15.2731C84.4541 15.5389 85.1963 15.7552 85.6751 15.9178C86.1524 16.0818 86.4612 16.2458 86.5985 16.414C86.7359 16.5822 86.8053 16.8028 86.8053 17.0785C86.8053 17.5168 86.6325 17.8589 86.2884 18.1035C85.9442 18.3481 85.4527 18.4711 84.8167 18.4711C84.042 18.4711 83.4032 18.2859 82.899 17.9169C82.3947 17.5479 82.0704 17.0361 81.9245 16.3829L78.334 16.9244C78.5663 18.3763 79.2221 19.5003 80.3028 20.2948C81.3834 21.0894 82.8012 21.4867 84.5575 21.4867C86.3139 21.4867 87.8124 21.0781 88.8449 20.2623C89.8775 19.4466 90.3944 18.324 90.3944 16.8975C90.3944 16.1751 90.2486 15.5587 89.9554 15.0483C89.6622 14.5365 89.1962 14.0982 88.5546 13.7335H88.5517Z"
      fill="white"
    />
    <path
      d="M103.462 7.18122V14.2445C103.462 15.1041 103.366 15.7983 103.172 16.3256C102.978 16.8544 102.73 17.2531 102.429 17.5245C102.128 17.7945 101.805 17.9783 101.461 18.0731C101.116 18.1678 100.794 18.2144 100.492 18.2144C99.7426 18.2144 99.1633 18.0462 98.7554 17.7111C98.3461 17.3761 98.0514 16.959 97.8701 16.4613C97.6889 15.9637 97.5812 15.4674 97.5472 14.9726C97.5132 14.4792 97.4962 14.072 97.4962 13.7539V7.17981H93.9326V14.991C93.9326 15.2229 93.9496 15.5933 93.9836 16.0994C94.0176 16.607 94.1167 17.1668 94.281 17.7818C94.4439 18.3968 94.7173 18.9864 95.1011 19.5547C95.4836 20.1216 96.0204 20.5896 96.7087 20.96C97.3971 21.329 98.288 21.5142 99.3814 21.5142C100.75 21.5142 101.884 21.2173 102.784 20.6249C103.207 20.3464 103.578 20.0255 103.901 19.665V21.1028H107V7.18122H103.462Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_navbar_logo"
        x1="0"
        y1="3.00713"
        x2="17.9356"
        y2="3.00713"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03BA99" />
        <stop offset="1" stopColor="#05F273" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_navbar_logo"
        x1="0"
        y1="21.0464"
        x2="0.141638"
        y2="21.0464"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03BA99" />
        <stop offset="1" stopColor="#05F273" />
      </linearGradient>
    </defs>
  </svg>
);
